import React from 'react';
import HellFire from './HellFire';
import './Rules.css';

const NUMERALS = ['I', 'II', 'III', 'IV', 'V'];

function Tablet({ items, startIndex }) {
  return (
    <div className="rules-tablet">
      <div className="tablet-face">
        {items.map((item, i) => (
          <React.Fragment key={i}>
            {i > 0 && <div className="tablet-groove" aria-hidden="true" />}
            <div className="tablet-commandment">
              <div className="tablet-numeral" aria-hidden="true">{NUMERALS[startIndex + i]}</div>
              <h3 className="tablet-title">{item.title}</h3>
              <p className="tablet-body">{item.body}</p>
            </div>
          </React.Fragment>
        ))}
      </div>
    </div>
  );
}

export default function Rules({ t }) {
  const left  = t.items.slice(0, 3);
  const right = t.items.slice(3);

  return (
    <section id="rules" className="rules">
      {/* Stone grain filter — coarse fractal noise for rough volcanic basalt */}
      <svg aria-hidden="true" style={{ position: 'absolute', width: 0, height: 0, overflow: 'hidden' }}>
        <defs>
          <filter id="stone-grain" x="-3%" y="-3%" width="106%" height="106%">
            <feTurbulence
              type="fractalNoise"
              baseFrequency="0.28 0.22"
              numOctaves="5"
              seed="7"
              stitchTiles="stitch"
              result="noise"
            />
            {/* Desaturate noise to grayscale */}
            <feColorMatrix type="saturate" values="0" in="noise" result="gray" />
            {/* Scale noise range from [0,1] → [0.65,1.0] and pin alpha to 1
                so multiply never punches through to transparent */}
            <feComponentTransfer in="gray" result="scaledGray">
              <feFuncR type="linear" slope="0.35" intercept="0.65" />
              <feFuncG type="linear" slope="0.35" intercept="0.65" />
              <feFuncB type="linear" slope="0.35" intercept="0.65" />
              <feFuncA type="linear" slope="0"    intercept="1"    />
            </feComponentTransfer>
            {/* Multiply: darkens stone colour by up to 35%, alpha stays 1 */}
            <feBlend in="SourceGraphic" in2="scaledGray" mode="multiply" />
          </filter>
        </defs>
      </svg>

      <HellFire />
      <div className="rules-inner">
        <div className="rules-header">
          <div className="rules-lintel">
            <h2 className="rules-title">{t.title}</h2>
            <p className="rules-subtitle">{t.subtitle}</p>
          </div>
        </div>

        <div className="tablets-row">
          <Tablet items={left}  startIndex={0} />
          <Tablet items={right} startIndex={3} />
        </div>
      </div>
    </section>
  );
}
